module.exports = __webpack_public_path__ + "img/social_4.c054a2f5.svg";